export const domainTag = 'frontend_portal_';

export const frontEndFlags = [
  'addSalesChannelTypeToStoreVisibility',
  'addStoresButton',
  'alertBannerInvoice',
  'deliveryLeadTime',
  'bulkVouchers',
  'enableTailwindBankDetails',
  'freeDeliveryFeeVoucher',
  'importCustomers',
  'hideNextOptionSetButtonOnSkip',
  'hideStoresPage2',
  'internationalisedAddress',
  'loyaltyMaxDiscount',
  'menuItemVoucher',
  'nestedModifiers',
  'orderFulfillmentStatusConfigurations',
  'orderFulfillmentStatusOrderDetails',
  'paygreenFeatures',
  'removePhotonHostnameAPI',
  'showBannerAlertForIntegratedMenus',
  'showAllMenusInEditor',
  'showPayoutsStoreOptions',
  'showPosInPayoutReport',
  'showPropertiesScreen',
  'showRMS',
  'showPropertyManagementPermissions',
  'hideStoreManagementPermissions',
  'tablePrefix',
  'tippingCustom',
  'tippingReduceValues',
  'tippingRoundUp',
  'useNewPayoutV3Report',
  'payoutsV3PayoutsByStore',
  'payoutsV3PropertyFilter',
  'enableClientReportingPayoutsMfe',
  'voucherChannel',
  'voucherDiscoverable',
  'voucherLimitAvailability',
  'voucherValidPeriod',
  'showSmsCampaigns',
  'homeOnBrandChange',
  'showRMSMenuSelectorForFDSalesChannels',
  'showSalesChannelStructure',
  'allowUpdateToBankingVatNumber',
  'redirectOrgToBrand',
  'enablePostcodePolygons',
  'enablePostcodePolygonsMultiple',
  'useStoresToSalesChannelRedirect',
  'showGoogleListingManagement',
  'enableMicroFrontendExampleManifestFile',
  'enableManifestMenuEditor',
  'showMenuListingV3',
  'showMenuEditorV3',
  'menuV3_showBulkActions',
  'menuV3_showScheduling',
  'menuV3_showRevertMenuButton',
  'menuV3_showUnifiedItemsView',
  'menuV3_showUnifiedModifiersView',
  'menuV3_showMenuValidationFeedback',
  'menuV3_showMenuSectionBehaviour',
  'menuV2_disableDrsForNonIeOrgs',
  'menuV3_disableDrsForNonIeOrgs',
  'moveWebToAppRedirectSetting',
  'enableManifestRestaurantLayoutDesigner',
  'disablePropertyManagerLevelAddOns',
  'enableIntercomCompanySync',
  'simplifiedRetentionCampaign',
  'showPortalSearch',
  'showAppendedSalesChannelTypes',
  'enableNewWebhooksSystem',
  'enableOnboardingV3WizardConfig',
  'enableOnboardingV3WizardAutoSave',
  'showCollectionSettingsAtPropertyLevel',
  'voucherFilteringImprovements',
  'customerVoucher',
  'showAssignedVouchersCustomerPage',
  'showVerifactuLink',
  'showAuthMenuItem',
  'showForceDiscount',
  'reportCategoryVisibility',
  'reportLabels',
  'marketplacesV2UberEats',
  'marketplacesV2Deliveroo',
  'marketplacesV2JustEat',
  'useGbpSearchFallbackTitlePostalCode',
  'enableBankAccountAndCompanyVerificationSteps',
  'expiryUsesStoreTimezone',
  'foodSafetyAddOnPermissions',
  'dashboards_useMicroFrontend',
  'dashboards_useMicroserviceSSO',
  'disableLegacyTeammate',
  'payout_failed_banner',
] as const;

export type FrontEndFlag = (typeof frontEndFlags)[number];
